import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSelectBar from "../Gen/SelectBar";

import DocumentListControls from "../Document/ListControls";

import { documentDisplayTitle } from "../../src/document_display_title";

interface DocumentSetDocumentRelationDeleteSelectListProps {
  document_set_id: number;
  documentSetDocumentRelations: ConnectedList<DocumentSnakeModel>;
}

function DocumentSetDocumentRelationDeleteSelectList(props: DocumentSetDocumentRelationDeleteSelectListProps) {
  const {
    document_set_id,
    documentSetDocumentRelations,
  } = props;

  React.useEffect(() => {
    documentSetDocumentRelations.mountList(`/document_sets/${document_set_id}/document_set_document_relations/delete_batch_list`);
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (documentSetDocumentRelations.selected.length === 0) {
      alert("Nothing Selected! You must select at least one member to remove.");
      return;
    }

    const data = {documentIds: documentSetDocumentRelations.selected.map((document) => document.id)};

    setIsSubmitLoading(true);

    fetch(`/document_sets/${document_set_id}/document_set_document_relations/destroy_batch_list`, {
      method: "DELETE",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response`); }

        return response.json();
      })
      .then(Turbo.visit(`/document_sets/${document_set_id}`))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [document_set_id, documentSetDocumentRelations.selected]);

  return(
    <div>
      <div className="submit-panel">
        <h1>Remove Cases From Course</h1>
        <GenButton
          name="Remove"
          highlighted
          loading={isSubmitLoading}
          onClick={handleSubmitButton}
        />
      </div>
      <GenSelectBar
        {...documentSetDocumentRelations}
        itemType="member(s)"
      />
      <DocumentListControls
        documents={documentSetDocumentRelations}
      />
      <GenListDisplay
        {...documentSetDocumentRelations}
        renderItem={(document) => <span>{documentDisplayTitle(document)}</span>}
      />
      <GenMore
        {...documentSetDocumentRelations}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(DocumentSetDocumentRelationDeleteSelectList, ["documentSetDocumentRelations"]);
